"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GFWithdrawnProfitProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const interfaces_1 = require("./interfaces");
const react_1 = require("react");
const apis_1 = require("./apis");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const useWithdrawnProfitCheckInfo_1 = require("./useWithdrawnProfitCheckInfo");
// 获取不允许提取利润的原因
const checkInfoReason = ({ reason, $st }) => {
    switch (reason) {
        default: {
            return $st("grid_futures_cur_profit_check_error");
        }
    }
};
/** 加仓 */
const GFWithdrawnProfitProcessor = (props) => {
    const { profit, open_price, exchangeOrder, $st } = props;
    const { checkInfo, queryCheckInfo, loading: checkLoading, } = (0, useWithdrawnProfitCheckInfo_1.useWithdrawnProfitCheckInfo)({
        profit: profit,
        open_price: open_price,
        orderId: exchangeOrder.id,
    });
    const submit = (0, react_1.useCallback)(() => {
        if (!profit || !Number(profit)) {
            return (0, rxjs_1.throwError)($st("trade_error_input_invest"));
        }
        if (!open_price) {
            return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
        }
        return queryCheckInfo().pipe((0, operators_1.mergeMap)((info) => {
            if (info.check_result) {
                return (0, apis_1.withDrawProfitAPI)({
                    amount: profit || "0",
                    type: interfaces_1.TransferType.profit,
                    orderId: exchangeOrder.id,
                    direction: interfaces_1.TransferDirection.out,
                    coin: exchangeOrder.quote,
                    open_price,
                });
            }
            const r = checkInfoReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
            if (r) {
                // 提取利润可能出现的报错
                return (0, rxjs_1.throwError)(r);
            }
            return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
        }));
    }, [$st, exchangeOrder.id, exchangeOrder.quote, open_price, profit, queryCheckInfo]);
    const profitError = (0, react_1.useMemo)(() => {
        const profitD = new trade_utils_lib_1.SafeDecimal(profit);
        if (profitD.eq(0)) {
            return "";
        }
        if (profitD.gt(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount))) {
            return $st("grid_futures_cur_profit_info_error");
        }
        return "";
    }, [$st, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount, profit]);
    const inputPlaceHolder = (0, react_1.useMemo)(() => {
        return $st("grid_futures_withdraw_placeholder");
    }, [$st]);
    const enableCommit = new trade_utils_lib_1.SafeDecimal(profit).gt(0) && !profitError && !checkLoading;
    const stopLossTriggerArrived = (0, react_1.useMemo)(() => {
        const { stop, loss_stop_type, totalProfit, initQuoteAmount } = exchangeOrder.exchangeGridV4FuturesOrder;
        if (loss_stop_type === TradeAPILib_1.GridStopType.price) {
            // 当使用价格止损时，则不做检查
            return false;
        }
        if (stop === undefined || stop === null) {
            // 当没有具体的止损值时，则不做检查
            return false;
        }
        const remainProfit = new trade_utils_lib_1.SafeDecimal(totalProfit).minus(new trade_utils_lib_1.SafeDecimal(profit));
        if (loss_stop_type === TradeAPILib_1.GridStopType.profit_amount) {
            return remainProfit.lt(new trade_utils_lib_1.SafeDecimal(stop));
        }
        if (loss_stop_type === TradeAPILib_1.GridStopType.profit_ratio) {
            return remainProfit.div(new trade_utils_lib_1.SafeDecimal(initQuoteAmount)).lt(new trade_utils_lib_1.SafeDecimal(stop));
        }
        return false;
    }, [exchangeOrder.exchangeGridV4FuturesOrder, profit]);
    return {
        checkInfo,
        checkLoading,
        submit,
        profitError,
        inputPlaceHolder,
        stopLossTriggerArrived,
        enableCommit,
    };
};
exports.GFWithdrawnProfitProcessor = GFWithdrawnProfitProcessor;
